module.exports = __webpack_public_path__ + "static/media/fuelBackground.3736e40c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Kiosk/CommitView/Fuel/fuelBackground.svg
// module id = 940
// module chunks = 0